import Text from 'components/common/Text';
import OpenBox from 'components/icons/OpenBox.js';
import Express from 'components/icons/signUp/Express';
import Extras from 'components/icons/signUp/Extras';
import FastAndFresh from 'components/icons/signUp/FastAndFresh';
import Microwave from 'components/icons/signUp/Microwave';
import OvenReady from 'components/icons/signUp/OvenReady';

import MealCard from './MealCard';

const MealCardContainer = ({ menuMeals }) => {
  const productTypes = {
    'Oven-Ready': { description: 'Easy Prep, No Mess', icon: OvenReady },
    Express: { description: '30 Minutes or Less', icon: Express },
    'Fast & Fresh': { description: 'Microwave or Oven', icon: FastAndFresh },
    'Heat & Eat': {
      description: 'Cooks in 2 Minutes',
      icon: Microwave,
    },
    'Tempo Meals': {
      description: 'Microwave in just 2 minutes',
      icon: OpenBox,
    },
    Extras: { icon: Extras },
    'Meal Kits': {
      description: 'Simple, Classic Recipes',
      icon: OpenBox,
    },
    'Family Meal Kits': {
      description: 'Simple, Classic Recipes',
      icon: OpenBox,
    },
  };

  return Object.keys(menuMeals).map(type => {
    if (!menuMeals[type]) return null;

    const Icon = productTypes[type].icon;

    return (
      <div key={type} className="mb-6">
        <div className="mb-1 flex items-center">
          <Icon className="h-8" />
          <Text className="ml-2" brandStylesOverrides="h6">
            {type}
          </Text>
        </div>

        {productTypes[type].description && (
          <Text className="mb-4 mt-1">{productTypes[type].description}</Text>
        )}

        <div className="grid grid-cols-2 bp2:grid-cols-3">
          {Object.values(menuMeals[type]).map(meal => (
            <MealCard key={meal.id} meal={meal} />
          ))}
        </div>
      </div>
    );
  });
};

MealCardContainer.propTypes = {
  menuMeals: PropTypes.object,
};

export default MealCardContainer;
